import { useMemo } from 'react'
import { useAppSelector } from '../../../../../store/hooks'
import { selectAccountId } from '../../../../../store/auth/authSlice'
import { RoomSession } from '../../../../../models/Room'
import { useGetUserAllocationContextUsersQuery } from '../../../../../store/media/media'
import { ASSIGNMENT_ROLE_NAME_MAPPING } from '../../MeetingSummary/ConfigureAssignment/AssignmentRoleNameMapping'
import { UserAllocationContextUser } from '../../../../../models/Allocation'

export const DEFAULT_ROLE = 'Unknown'

export const useMeetingUsers = (roomSession: RoomSession | null, identityTypes?: string[]) => {
  const accountId = useAppSelector(selectAccountId)
  const { roomId = '', id: sessionId = '' } = roomSession || {}

  const {
    data: allocationContextUsers,
    isFetching,
    refetch,
  } = useGetUserAllocationContextUsersQuery({ accountId, roomId, sessionId, identityTypes }, { skip: !roomId || !sessionId, refetchOnMountOrArgChange: true })

  const usersByRoles = useMemo(() => {
    if (!allocationContextUsers?.data) {
      return {}
    }

    return allocationContextUsers.data.reduce((acc: { [key: string]: UserAllocationContextUser[] }, allocationContextUser) => {
      const { user } = allocationContextUser
      const roleName = !user.roles.length ? DEFAULT_ROLE : (ASSIGNMENT_ROLE_NAME_MAPPING[user.roles[0].id] ?? user.roles[0].name)

      if (!acc[roleName]) {
        acc[roleName] = []
      }
      acc[roleName].push(allocationContextUser)

      return acc
    }, {})
  }, [allocationContextUsers])

  return { usersByRoles, isFetching, refetchUsers: refetch }
}
